module.exports = __webpack_public_path__ + "img/logo_daegurostore.ecc40540.jpg";